import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';
import Verification from '../container/profile/authentication/overview/Verifiction';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const SignUp = lazy(() => import('../container/profile/authentication/overview/SignUp'));
const SignUpSummary = lazy(() => import('../container/profile/authentication/overview/SignUpSummary'));
const ForgotPass = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));
const ResetPass = lazy(() => import('../container/profile/authentication/overview/ResetPassword'));

const AuthRoot = () => {
  const navigate = useNavigate();
  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="verify/:id/:hash" element={<Verification />} />
      <Route path="forgotPassword" element={<ForgotPass />} />
      <Route path="reset-password" element={<ResetPass />} />
      <Route path="register" element={<SignUp />} />
      <Route path="register/summary/:uuid" element={<SignUpSummary />} />
      <Route path="*" element={<AuthRoot />} />
    </Routes>
  );
});

export default AuthLayout(FrontendRoutes);
